<div class="allert-badge-container ic1-mt-10">
  <app-migration-banner
    *ngIf="showMigrationBanner && session.icssUser"></app-migration-banner>
</div>
<div class="allert-badge-container ic1-mt-10 expiratin_toast">
  <ng-ui-kit-toast
    *ngIf="isExpirationToast && renewable"
    [text]="
      'HOMEPAGE.TOAST_MESSAGE.RENEWABLE'
        | translate: { expiration_date: expirationDate }
    "
    status="warning"
    [action]="action"
    [hideClose]="true">
  </ng-ui-kit-toast>
  <ng-ui-kit-toast
    *ngIf="isExpirationToast && !renewable"
    [text]="
      'HOMEPAGE.TOAST_MESSAGE.NOT_RENEWABLE'
        | translate: { expiration_date: expirationDate }
    "
    status="warning"
    [hideClose]="true">
  </ng-ui-kit-toast>
</div>
<div *ngIf="isCertValid$ | async" id="cards-wrapper" class="ic1-row ic1-mt-100">
  <div class="ic1-col-lg-4 ic1-col-12">
    <ng-ui-kit-card
      type="elevated"
      [title]="'HOMEPAGE.CERT.TITLE' | translate"
      [text]="'HOMEPAGE.CERT.DESC' | translate"
      iconLeft="person"
      [ariaLabelAction]="
        'COMMON.OPEN_SECTION' | translate: {
          section: ('HOMEPAGE.CERT.TITLE' | translate)
        }
      "
      [attr.translate-key]="'HOMEPAGE.CERT.TITLE,HOMEPAGE.CERT.DESC'"
      (onClick)="onClick('cert')">
    </ng-ui-kit-card>
  </div>
  <div class="ic1-col-lg-4 ic1-col-12" *ngIf="!isTrissTokenHardware">
    <ng-ui-kit-card
      type="elevated"
      [title]="'HOMEPAGE.OTP.TITLE' | translate"
      [attr.translate-key]="'HOMEPAGE.OTP.TITLE,HOMEPAGE.OTP.DESC'"
      [text]="'HOMEPAGE.OTP.DESC' | translate"
      iconLeft="password"
      [ariaLabelAction]="
        'COMMON.OPEN_SECTION' | translate: {
          section: ('HOMEPAGE.OTP.TITLE' | translate)
        }
      "
      (onClick)="onClick('otp')">
    </ng-ui-kit-card>
  </div>

  <div class="ic1-col-lg-4 ic1-col-12" *ngIf="isPkBox">
    <ng-ui-kit-card
      type="elevated"
      [title]="'HOMEPAGE.REPORT.TITLE' | translate"
      [attr.translate-key]="'HOMEPAGE.REPORT.TITLE,HOMEPAGE.REPORT.DESC'"
      [text]="'HOMEPAGE.REPORT.DESC' | translate"
      iconLeft="mark_email_unread"
      [ariaLabelAction]="
        'COMMON.OPEN_SECTION' | translate: {
          section: ('HOMEPAGE.REPORT.TITLE' | translate)
        }
      "
      (onClick)="onClick('report')">
    </ng-ui-kit-card>
  </div>
  <div class="ic1-col-lg-4 ic1-col-12" *ngIf="isIcssUser || isTrissUser">
    <ng-ui-kit-card
      type="elevated"
      [title]="'HOMEPAGE.ACTION_REPORT.TITLE' | translate"
      [attr.translate-key]="
        'HOMEPAGE.ACTION_REPORT.TITLE,HOMEPAGE.ACTION_REPORT.DESC'
      "
      [text]="'HOMEPAGE.ACTION_REPORT.DESC' | translate"
      iconLeft="history"
      [ariaLabelAction]="
        'COMMON.OPEN_SECTION' | translate: {
          section: ('HOMEPAGE.ACTION_REPORT.TITLE' | translate)
        }
      "
      (onClick)="onClick('actionReport')">
    </ng-ui-kit-card>
  </div>
  <div class="ic1-col-lg-4 ic1-col-12">
    <ng-ui-kit-card
      type="elevated"
      [title]="'HOMEPAGE.PIN.TITLE' | translate"
      [attr.translate-key]="'HOMEPAGE.PIN.TITLE,HOMEPAGE.PIN.DESC'"
      [text]="'HOMEPAGE.PIN.DESC' | translate"
      iconLeft="edit"
      [ariaLabelAction]="
        'COMMON.OPEN_SECTION' | translate: {
          section: ('HOMEPAGE.PIN.TITLE' | translate)
        }
      "
      (onClick)="onClick('pin')">
    </ng-ui-kit-card>
  </div>
  <div class="ic1-col-lg-4 ic1-col-12" *ngIf="renewable && !renewalTrissForAutomaticOrEseal ">
    <ng-ui-kit-card
      type="elevated"
      [title]="'HOMEPAGE.RENEW.TITLE' | translate"
      [attr.translate-key]="'HOMEPAGE.RENEW.TITLE,HOMEPAGE.RENEW.DESC'"
      [text]="'HOMEPAGE.RENEW.DESC' | translate"
      iconLeft="sync"
      [ariaLabelAction]="
        'COMMON.OPEN_SECTION' | translate: {
          section: ('HOMEPAGE.RENEW.TITLE' | translate)
        }
      "
      (onClick)="onClick('renew')">
    </ng-ui-kit-card>
  </div>
  <div class="ic1-col-lg-4 ic1-col-12" *ngIf="suspendable">
    <ng-ui-kit-card
      type="elevated"
      [title]="'HOMEPAGE.SUSPEND.TITLE' | translate"
      [attr.translate-key]="'HOMEPAGE.SUSPEND.TITLE,HOMEPAGE.SUSPEND.DESC'"
      [text]="'HOMEPAGE.SUSPEND.DESC' | translate"
      iconLeft="pause_circle"
      [ariaLabelAction]="
        'COMMON.OPEN_SECTION' | translate: {
          section: ('HOMEPAGE.SUSPEND.TITLE' | translate)
        }
      "
      (onClick)="onClick('suspend')">
    </ng-ui-kit-card>
  </div>
  <div class="ic1-col-lg-4 ic1-col-12" *ngIf="automatic && isPkBox">
    <ng-ui-kit-card
      type="elevated"
      [title]="'HOMEPAGE.MANAGE_CERT.TITLE' | translate"
      [attr.translate-key]="
        'HOMEPAGE.MANAGE_CERT.TITLE,HOMEPAGE.MANAGE_CERT.DESC'
      "
      [text]="'HOMEPAGE.MANAGE_CERT.DESC' | translate"
      iconLeft="manage_accounts"
      [ariaLabelAction]="
        'COMMON.OPEN_SECTION' | translate: {
          section: ('HOMEPAGE.MANAGE_CERT.TITLE' | translate)
        }
      "
      (onClick)="onClick('manageCert')">
    </ng-ui-kit-card>
  </div>
  <div class="ic1-col-lg-4 ic1-col-12">
    <ng-ui-kit-card
      type="elevated"
      [title]="'HOMEPAGE.ESG.TITLE' | translate"
      [attr.translate-key]="'HOMEPAGE.ESG.TITLE,HOMEPAGE.ESG.DESC'"
      [text]="'HOMEPAGE.ESG.DESC' | translate"
      iconLeft="eco"
      [ariaLabelAction]="
        'COMMON.OPEN_SECTION' | translate: {
          section: ('HOMEPAGE.ESG.TITLE' | translate)
        }
      "
      (onClick)="onClick('esg')"
      class="green-icon">
    </ng-ui-kit-card>
  </div>
</div>

<app-common-modal
  modalId="status-modal"
  [(visible)]="statusModalVisible"
  [config]="{ size: 'md', persistent: true, hideButtons: true }"
  (onClose)="onToggleStatusModal(false)">
  <div [ngSwitch]="certificateStatus">
    <div *ngSwitchCase="'SUSPENDED'" class="modal-content">
      <img src="assets/images/cert-suspended.svg" />
      <div class="title" translate>HOMEPAGE.STATUS_MODAL.SUSPENDED.TITLE</div>
      <div class="text" translate>HOMEPAGE.STATUS_MODAL.SUSPENDED.DESC</div>
      <div class="text" translate>HOMEPAGE.STATUS_MODAL.SUSPENDED.CONTACT</div>
      <ng-ui-kit-button
        (onClick)="openSupport()"
        color="primary"
        [label]="'HOMEPAGE.STATUS_MODAL.BUTTON' | translate"
        type="button"
        size="sm">
      </ng-ui-kit-button>
    </div>

    <div *ngSwitchCase="'EXPIRED'" class="modal-content">
      <img src="assets/images/cert-suspended.svg" />
      <div class="title" translate>HOMEPAGE.STATUS_MODAL.EXPIRED.TITLE</div>
      <div class="text" translate>HOMEPAGE.STATUS_MODAL.EXPIRED.DESC</div>
      <div class="text" translate>HOMEPAGE.STATUS_MODAL.EXPIRED.CONTACT</div>
      <ng-ui-kit-button
        (onClick)="openSupport()"
        color="primary"
        [label]="'HOMEPAGE.STATUS_MODAL.BUTTON' | translate"
        type="button"
        size="sm">
      </ng-ui-kit-button>
    </div>

    <div *ngSwitchCase="'REVOKED'" class="modal-content">
      <img src="assets/images/cert-revoked.svg" />
      <div class="title" translate>HOMEPAGE.STATUS_MODAL.REVOKED.TITLE</div>
      <div class="text" translate>HOMEPAGE.STATUS_MODAL.REVOKED.DESC</div>
      <div class="text" translate>HOMEPAGE.STATUS_MODAL.REVOKED.CONTACT</div>
      <ng-ui-kit-button
        (onClick)="openSupport()"
        color="primary"
        [label]="'HOMEPAGE.STATUS_MODAL.BUTTON' | translate"
        type="button"
        size="sm">
      </ng-ui-kit-button>
    </div>

    <div
      *ngSwitchCase="
        ['INVALID', 'NOT_VALID'].includes(certificateStatus)
          ? certificateStatus
          : !certificateStatus
      "
      class="modal-content">
      <img src="assets/images/cert-revoked.svg" />
      <div class="title" translate>HOMEPAGE.STATUS_MODAL.INVALID.TITLE</div>
      <div class="text" translate>HOMEPAGE.STATUS_MODAL.INVALID.DESC</div>
      <div class="text" translate>HOMEPAGE.STATUS_MODAL.INVALID.DESC_2</div>
      <ng-ui-kit-button
        (onClick)="openSupport()"
        color="primary"
        [label]="'HOMEPAGE.STATUS_MODAL.BUTTON' | translate"
        type="button"
        size="sm">
      </ng-ui-kit-button>
    </div>
  </div>
</app-common-modal>
